import FAApi from './_faVoucherListApi';
import httpClient from '@/apis/base/httpclient';

class FAVoucherListApi extends FAApi {
  constructor() {
    super();
  }
  controllerName = 'favouchers';
  /**
   * Lấy full danh sách chứng từ
   * ndquang1 10.07.2023
   * @returns data
   */
  getFullVoucher() {
    let request = {
      url: this.getAPIUrl() + `/GetFullVoucher`,
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy tài khoản mặc định
   * pdtai 13.07.2023
   * */
  getDefaultAccount() {
    let request = {
      url: this.getAPIUrl() + `/defaultAccounts`,
      data: {},
    };
    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu combox tài sản cho chứng từ TSCĐ
   * ndquang1 13.07.2023
   * @returns data
   */
  GetComboboxFixedAssetData(ref_type, start_date, skip, take, filter) {
    let request = {
      url: this.getAPIUrl() + '/DataCombobox',
      data: {
        ref_type: ref_type,
        start_date: start_date,
        skip: skip,
        take: take,
        filter: filter,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu tài sản theo id
   * ndquang1 17.07.2023
   * @returns data
   */
  GetFixedAssetData(fixed_asset_id, year) {
    let request = {
      url: this.getAPIUrl() + '/GetFixedAsset',
      data: {
        fixed_asset_id: fixed_asset_id,
        year: year,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy dữ liệu tài sản có ngày bắt đầu sử dụng bé hơn ngày được chọn
   * ndchien1 - 14.09.2023
   * @returns data
   */
  GetFixedAssetByUseDate(date) {
    let request = {
      url: this.getAPIUrl() + '/GetFixedAssetByUseDate',
      data: {
        date: date,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Lấy trạng thái cho phép thêm sửa chứng từ điều chỉnh không
   * pdtai 17.07.2023
   * @returns data
   */
  GetActionStatusAddEdit(mode, id, postedDate) {
    let request = {
      url: this.getAPIUrl() + '/ActionStatus',
      data: {
        mode: mode,
        id: id,
        postedDate: postedDate,
      },
    };

    return httpClient.getAsync(request);
  }

  /**
   * Cập nhật lại chứng từ ảnh hưởng chuyển thông tư
   * @param {*} payload
   * @returns
   */
  updateVoucherEffect(param) {
    const request = {
      url: this.getAPIUrl() + '/UpdateVoucherEffect?isCreateNew=' + param.isCreateNew,
      data: param.data,
    };
    return httpClient.postAsync(request);
  }

  /**
   * Thêm mới nhiều chứng từ ghi tăng cùng 1 lúc
   */
  insertMultiFaVoucher(payload) {
    const request = {
      url: this.getAPIUrl() + '/batch',
      data: payload,
    };
    return httpClient.postAsync(request, true);
  }
  /**
   * @description: lấy dữ liệu TSCĐ phục vụ hướng dẫn quyết toán
   * @param: {any}
   * @return: {any}
   * CreatedBy: KBNGUYET 07/01/2025
   */
  getSettlementFaVoucher(year, useQlts, caseNumber) {
    let request = {
      url: this.getAPIUrl() + '/settlement-instruction-fa-voucher',
      data: {
        year: year,
        useQlts: useQlts,
        caseNumber: caseNumber,
      },
    };
    return httpClient.getAsync(request);
  }
}

export default new FAVoucherListApi();
